import { createRoot } from 'react-dom/client';
import '@fontsource/orbitron/400.css';
import '@fontsource/orbitron/700.css';
import '@fontsource/orbitron/900.css';
import './styles/global.css';
import App from './App';

// 注意：刻意不用 StrictMode——3D 内核（CubeKernel/WebGL 资源）是命令式单例，
// StrictMode 的双挂载会导致重复创建与销毁竞态。
createRoot(document.getElementById('root')!).render(<App />);
